import { render, staticRenderFns } from "./SpreadItem.vue?vue&type=template&id=5b449dc0&scoped=true&"
import script from "./SpreadItem.vue?vue&type=script&lang=js&"
export * from "./SpreadItem.vue?vue&type=script&lang=js&"
import style0 from "./SpreadItem.vue?vue&type=style&index=0&id=5b449dc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b449dc0",
  null
  
)

export default component.exports